<template>
  <div class="app-store-page">
    <StatusBar />
    <!-- <TopNav /> -->
    <AppHeader />
    <StatsRow />
    <ScreenshotsGallery />
    <DescriptionSection />
    <RatingsReviews />
    <WhatsNew />
    <AppPrivacy />
    <AccessibilitySection />
    <InformationSection />
    <!-- <MoreByDeveloper /> -->
    <YouMightAlsoLike />
    <p class="footer-disclaimer">{{ t('appStore.footerDisclaimer') }}</p>
    <!-- <TabBar /> -->
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import StatusBar from './components/StatusBar.vue';
import TopNav from './components/TopNav.vue';
import AppHeader from './components/AppHeader.vue';
import StatsRow from './components/StatsRow.vue';
import ScreenshotsGallery from './components/ScreenshotsGallery.vue';
import DescriptionSection from './components/DescriptionSection.vue';
import RatingsReviews from './components/RatingsReviews.vue';
import WhatsNew from './components/WhatsNew.vue';
import AppPrivacy from './components/AppPrivacy.vue';
import AccessibilitySection from './components/AccessibilitySection.vue';
import InformationSection from './components/InformationSection.vue';
import MoreByDeveloper from './components/MoreByDeveloper.vue';
import YouMightAlsoLike from './components/YouMightAlsoLike.vue';
import TabBar from './components/TabBar.vue';

const { t } = useI18n();
</script>

<style scoped>
.app-store-page {
  background: #fff;
  min-height: 100%;
  padding-bottom: 8px;
}

.footer-disclaimer {
  margin: 32px 16px 16px;
  text-align: center;
  font-size: 11px;
  line-height: 1.4;
  color: #9ca3af;
}
</style>
